import { maxBy } from 'lodash';
import { createSelector } from 'reselect';

import { getTasks } from './index';

const lastActivityForLead = (lead, tasks) => maxBy(activitiesForLead(lead, tasks), 'completedAt');
const leadIsAssociatedWithTask = (lead, task) => (
  task.associatedModels.find(model => (
    model.associatedModelType === lead.contactType && model.associatedModelId === lead.contactId
  ))
);

export const getLeads = state => state.leads;
export const getProject = state => state.project;
export const getPossibleLeadReferralSources = state => state.leadsOptions.selectOptions.referralSources;
export const getPossibleLeadStatuses = state => state.leadsOptions.selectOptions.statuses;
export const getSelectedLeads = state => state.selectedLeads;
export const isFetchingLeads = state => state.leads.fetching;
// NOTE: if leads is not an array, it means it has either not been fetched or is currently being fetched
// TODO: modify leads to always be an object instead of starting as an object and turning into an array
export const shouldFetchLeads = state => (
  typeof state.leads === 'object' && !Array.isArray(state.leads) && !state.leads.isFetching
);
export const tasksForLead = (lead, tasks) => {
  if (!tasks || tasks.fetching) return [];
  return tasks.filter(task => !task.completed && leadIsAssociatedWithTask(lead, task));
};

export const activitiesForLead = (lead, tasks) => {
  if (!tasks || tasks.fetching) return [];

  return tasks.filter(task => task.completed && leadIsAssociatedWithTask(lead, task));
};

export const getDecoratedLeads = createSelector(
  [getLeads, getTasks],
  (leads, tasks) => {
    if (isFetchingLeads({ leads }) || shouldFetchLeads({ leads })) return [];

    return leads.map((lead) => {
      const lastTask = lastActivityForLead(lead, tasks) || {};
      const lastActivityDate = lastTask.completedAt;
      const lastActivityType = lastTask.taskType;

      return { ...lead, lastActivityDate, lastActivityType };
    });
  }
);
